function scrollToElement(element, behavior, block) {
    element.scrollIntoView({
        behavior: behavior ? behavior : 'smooth',
        block: block ? block : 'start'
    });
}
function scrollToTop(behavior) {
    window.scrollTo({
        top: 0,
        behavior: behavior ? behavior : 'smooth'
    });
}
function scrollTo(position, behavior) {
    window.scrollTo({
        top: position.y,
        left: position.x,
        behavior: behavior ? behavior : 'smooth'
    });
}

/**
 * Generated bundle index. Do not edit.
 */

export { scrollTo, scrollToElement, scrollToTop };
